// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__31Yfb","footer":"Form_footer__lMhyg"};